/* global document */
import angular from 'angular';
import animations from 'app/main/animations';
import ngAria from 'angular-aria';
import ngCookies from 'angular-cookies';
import ngMaterial from 'angular-material';
import ngSanitize from 'angular-sanitize';
import 'angular-moment-picker';
import ngInfiniteScroll from 'ng-infinite-scroll';
import {
 loaderService, userService, appVersionService, utilityService
} from 'app/services';
import interceptors from 'app/interceptors';
import components from 'app/components';
import {
  dashboard,
  ssTooltip,
  systemNotifications,
  appVersionDialog
} from 'app/components/global';
import config from 'app/main/config';
import controller from 'app/main/thesafe.app.controller';
import 'app/sass/index.scss';
import 'app/adalProviders/adal.angular';

const app = angular.module('theSafeApp', [
  animations,
  appVersionDialog,
  appVersionService,
  ngAria,
  ngCookies, // Used by app.config
  ngMaterial,
  ngSanitize,
  interceptors,
  loaderService, // Used by app.controller
  components,
  dashboard, // Used by index.html
  ssTooltip, // Used almost everywhere and is an essential part of the app
  systemNotifications, // Used by index.html
  'moment-picker',
  ngInfiniteScroll,
  userService,
  'AdalAngular',
  utilityService,
])
  .config(config)
  .controller('TheSafeAppController', controller);
  // .run((
  //   $location,
  //   $rootScope,
  //   authorizationService
  // ) => {
  //   let postLogInRoute;
  //   const path = $location.path();
  //   const pathRequiresLogin = (path !== '/login' && path !== '/password' && path.indexOf('/id_token') === -1);
  //   $rootScope.$on('$routeChangeStart', (event, nextRoute) => {
  //     console.log(event, nextRoute);
  //     // if login required and you're logged out, capture the current path
  //     if (pathRequiresLogin && !authorizationService.getToken()) {
  //       postLogInRoute = $location.path();
  //       $location.path('/login').replace();
  //     } else if (postLogInRoute && authorizationService.getToken()) {
  //     // once logged in, redirect to the last route and reset it
  //       $location.path(postLogInRoute).replace();
  //       postLogInRoute = null;
  //     }
  //   });
  // });
// .run(['notify', (notify) => notify.config({})]); // <-- Used when there is something to config for notify

angular.element(() => {
  angular.bootstrap(document, ['theSafeApp']);
  console.log('app bootstrapped (theSafeApp)');
});

export default app.name;
